import { useResponsiveness } from './ResponsivenessProvider';
export const useResponsiveDims = (dimensionsArray = []) => {
  const {
    isMobile
  } = useResponsiveness();
  return dimensionsArray && dimensionsArray.length && (isMobile ? dimensionsArray[0] : dimensionsArray[1]);
};